$(document).ready(function(){
  // $(".js-read").click(function(){
  //   $(this).prev().toggle( "slow");
  //   $(".more-li").toggle("slow");
  //   if($(this).html()=='<span>Leggi tutto</span><i class="icon icon-arrow-down-readmore-blue-bapr"></i>'){
  //     $(this).html('<span>Leggi meno</span><i class="icon icon-arrow-up-readmore-blue-bapr"></i>');
  //   }
  //   else{
  //     $(this).html('<span>Leggi tutto</span><i class="icon icon-arrow-down-readmore-blue-bapr"></i>');
  //   }
  // });
  $(".js-reduce").click(function(){
    $(this).prev().toggle( "slow");
    $(".more-li").toggle("slow");
    if($(this).html()=='<span>Scopri di più</span><i class="icon icon-arrow-down-readmore-blue-bapr"></i>'){
      $(this).html('<span>Riduci</span><i class="icon icon-arrow-up-readmore-blue-bapr"></i>');
    }
    else{
      $(this).html('<span>Scopri di più</span><i class="icon icon-arrow-down-readmore-blue-bapr"></i>');
    }
  });
});

